var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useLegacy)?_c('recipes-legacy',{on:{"new-view":_vm.useNewView}}):(_vm.restaurantId)?_c('div',[(_vm.isPhone)?_c('recipes-mobile'):_c('recipes-desktop')],1):_c('div',{staticClass:"pa-6"},[_c('page-header',{attrs:{"icon":"mdi-book-open-page-variant","title":_vm.$t('recipes'),"subtitle":_vm.$t('please_select_restaurant_to_view_data')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }